// extracted by mini-css-extract-plugin
module.exports = {"schools":"schools_schools__1akt_","type":"schools_type__2T0FX","name":"schools_name__IMU_x","showButton":"schools_showButton__VoONI","infoIcon":"schools_infoIcon__OF09h"};